import Button from '@components/v2/ui/Button/Button';
import { Box, CircularProgress } from '@mui/material';
import LangEnum from '../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../../modules/translation/TranslationContext';
import { ColumnsVisibilityTestIds } from '../../../../../../utils/testIds/columnsVisibility.testIds';

interface ApplyConfig {
  onApply: () => void;
  canApply: boolean;
  isApplying: boolean;
}

interface RestoreConfig {
  onRestore: () => void;
  canRestore: boolean;
}

interface ColumnsVisibilityFooterProps {
  applyConfig: ApplyConfig;
  restoreConfig: RestoreConfig;
}

const ColumnsVisibilityFooter = ({ applyConfig, restoreConfig }: ColumnsVisibilityFooterProps) => {
  const { translate } = useTranslation();
  const { onApply, canApply, isApplying } = applyConfig;
  const { onRestore, canRestore } = restoreConfig;

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        gap: 1,
        padding: 1,
        borderTop: 1,
        borderColor: 'divider',
      }}
    >
      <Button
        variant="text"
        color="secondary"
        size="medium"
        disabled={!canRestore}
        onClick={onRestore}
        testId={ColumnsVisibilityTestIds.RESTORE_BUTTON}
      >
        {translate(LangEnum.GLOBAL_RESTORE)}
      </Button>
      <Button
        variant="contained"
        color="primary"
        size="medium"
        disabled={!canApply}
        onClick={onApply}
        testId={ColumnsVisibilityTestIds.SAVE_BUTTON}
        endIcon={isApplying ? <CircularProgress size={16} /> : undefined}
      >
        {translate(LangEnum.GLOBAL_APPLY)}
      </Button>
    </Box>
  );
};

export default ColumnsVisibilityFooter;
